import type { SupabaseClient } from "@supabase/supabase-js";

type Role = "admin" | "employer" | "job_seeker" | "candidate";
type Opts = {
  supabase: SupabaseClient;
  roleHint?: Role | null;
  timeoutMs?: number;
};

export async function computeDashboardDest({
  supabase,
  roleHint = null,
  timeoutMs = 1000,
}: Opts): Promise<string> {
  const t0 = performance.now();
  try {
    // 1) Must have a session/user
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return "/coming-soon";

    // 2) Load role (robust to any shape)
    const { data, error } = await supabase
      .from("profiles")
      .select("role")
      .eq("user_id", user.id)
      .maybeSingle();             // returns object | null

    if (error) console.warn("[redir] profiles role lookup failed:", error);

    let role: Role | null = (data?.role ?? null) as Role | null;
    if (role === "candidate") role = "job_seeker"; // normalize

    // 3) Decide destination
    if (role === "admin" || roleHint === "admin") return "/admin/overview";
    if (role === "employer" || roleHint === "employer") return "/employer/dashboard";
    if (role === "job_seeker" || roleHint === "job_seeker") return "/job-seeker/dashboard";

    // 4) No role yet → let user choose
    return "/coming-soon";
  } catch (e) {
    console.warn("[redir] computeDashboardDest error:", e);
    return "/coming-soon";        // fallback while auth is disabled
  } finally {
    console.log("[redir] ms =", Math.round(performance.now() - t0));
  }
}
